import {
  Button,
  Card,
  CardContent,
  Collapse,
  Grid,
  Switch,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { SettingsInputHdmiOutlined } from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

function isValidIPv4(str: string) {
  return /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/g.test(
    str
  );
}

type NetworkEthProps = {
  handleBack: () => void;
  handleNext: (configuration: any) => void;
};

const NetworkEth: React.FC<NetworkEthProps> = ({ handleBack, handleNext }) => {
  const { t } = useTranslation();

  const [configuration, setConfiguration] = useState<any>({
    IFCS: [
      {
        ifc_name: "eth",
        ifc_params: { dhcp: true, ip: "", mask: "", gateway: "", dns: "" },
      },
    ],
  });

  useEffect(() => {
    console.log("NET.JSON", configuration);
  }, [configuration]);

  return (
    <Grid
      container
      spacing={2}
      direction="column"
      alignItems="center"
      justifyContent="center"
    >
      <Grid item>
        <SettingsInputHdmiOutlined fontSize="large" />
      </Grid>
      <Grid item>
        <Typography variant="h5">{t("ethernetSettings")}</Typography>
      </Grid>
      <Grid item>
        <Typography>{t("ethernetDescription")}</Typography>
      </Grid>
      <Grid
        container
        item
        spacing={4}
        alignItems="center"
        justifyContent="center"
      >
        <Grid item xs={12} md={8} xl={6}>
          <Card variant="outlined">
            <CardContent style={{ margin: "8px" }}>
              <Grid container spacing={1} direction="column">
                <Grid item>
                  <Typography variant="h6">{t("ipv4")}</Typography>
                </Grid>
                <Grid item>
                  <Switch
                    checked={!configuration.IFCS[0].ifc_params.dhcp}
                    onChange={() =>
                      setConfiguration({
                        ...configuration,
                        IFCS: [
                          {
                            ...configuration.IFCS[0],
                            ifc_params: {
                              ...configuration.IFCS[0].ifc_params,
                              dhcp: !configuration.IFCS[0].ifc_params.dhcp,
                            },
                          },
                        ],
                      })
                    }
                  />
                  {!configuration.IFCS[0].ifc_params.dhcp
                    ? " " + t("manual")
                    : " " + t("automaticDhcp")}
                </Grid>
                <Grid item>
                  <Collapse
                    in={!configuration.IFCS[0].ifc_params.dhcp}
                    timeout="auto"
                    unmountOnExit
                  >
                    <Grid container spacing={1} direction="column">
                      <Grid item>
                        <TextField
                          onChange={(e) =>
                            setConfiguration({
                              ...configuration,
                              IFCS: [
                                {
                                  ...configuration.IFCS[0],
                                  ifc_params: {
                                    ...configuration.IFCS[0].ifc_params,
                                    ip: e.target.value,
                                  },
                                },
                              ],
                            })
                          }
                          value={configuration.IFCS[0].ifc_params.ip}
                          fullWidth
                          size="small"
                          label={t("ipAddress")}
                          error={
                            !!configuration.IFCS[0].ifc_params.ip &&
                            !isValidIPv4(configuration.IFCS[0].ifc_params.ip)
                          }
                          helperText={
                            !!configuration.IFCS[0].ifc_params.ip &&
                            !isValidIPv4(configuration.IFCS[0].ifc_params.ip)
                              ? t("invalidIpv4Address")
                              : undefined
                          }
                        />
                      </Grid>
                      <Grid item>
                        <TextField
                          onChange={(e) =>
                            setConfiguration({
                              ...configuration,
                              IFCS: [
                                {
                                  ...configuration.IFCS[0],
                                  ifc_params: {
                                    ...configuration.IFCS[0].ifc_params,
                                    mask: e.target.value,
                                  },
                                },
                              ],
                            })
                          }
                          value={configuration.IFCS[0].ifc_params.subnetMask}
                          fullWidth
                          size="small"
                          label={t("subnetMask")}
                          error={
                            !!configuration.IFCS[0].ifc_params.subnetMask &&
                            !isValidIPv4(
                              configuration.IFCS[0].ifc_params.subnetMask
                            )
                          }
                          helperText={
                            !!configuration.IFCS[0].ifc_params.subnetMask &&
                            !isValidIPv4(
                              configuration.IFCS[0].ifc_params.subnetMask
                            )
                              ? t("invalidIpv4Address")
                              : undefined
                          }
                        />
                      </Grid>
                      <Grid item>
                        <TextField
                          onChange={(e) =>
                            setConfiguration({
                              ...configuration,
                              IFCS: [
                                {
                                  ...configuration.IFCS[0],
                                  ifc_params: {
                                    ...configuration.IFCS[0].ifc_params,
                                    gateway: e.target.value,
                                  },
                                },
                              ],
                            })
                          }
                          value={configuration.IFCS[0].ifc_params.gateway}
                          fullWidth
                          size="small"
                          label={t("gateway")}
                          error={
                            !!configuration.IFCS[0].ifc_params.gateway &&
                            !isValidIPv4(
                              configuration.IFCS[0].ifc_params.gateway
                            )
                          }
                          helperText={
                            !!configuration.IFCS[0].ifc_params.gateway &&
                            !isValidIPv4(
                              configuration.IFCS[0].ifc_params.gateway
                            )
                              ? t("invalidIpv4Address")
                              : undefined
                          }
                        />
                      </Grid>
                      <Grid item>
                        <TextField
                          onChange={(e) =>
                            setConfiguration({
                              ...configuration,
                              IFCS: [
                                {
                                  ...configuration.IFCS[0],
                                  ifc_params: {
                                    ...configuration.IFCS[0].ifc_params,
                                    dns: e.target.value,
                                  },
                                },
                              ],
                            })
                          }
                          value={configuration.IFCS[0].ifc_params.dns}
                          fullWidth
                          size="small"
                          label={t("dns")}
                          error={
                            !!configuration.IFCS[0].ifc_params.dns &&
                            !isValidIPv4(configuration.IFCS[0].ifc_params.dns)
                          }
                          helperText={
                            !!configuration.IFCS[0].ifc_params.dns &&
                            !isValidIPv4(configuration.IFCS[0].ifc_params.dns)
                              ? t("invalidIpv4Address")
                              : undefined
                          }
                        />
                      </Grid>
                    </Grid>
                  </Collapse>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
          <Grid
            container
            spacing={2}
            display="flex"
            alignItems="flex-start"
            justifyContent="space-between"
          >
            <Grid item>
              <Button
                size="large"
                variant="outlined"
                style={{ float: "right", marginTop: "8px" }}
                onClick={handleBack}
              >
                {t("back")}
              </Button>
            </Grid>
            <Tooltip title={""}>
              <Grid item>
                <Button
                  size="large"
                  variant="contained"
                  style={{ float: "right", marginTop: "8px" }}
                  onClick={() => {
                    const filteredConfiguration = {
                      ...configuration,
                      IFCS: configuration.IFCS.map((ifc: any) => ({
                        ...ifc,
                        ifc_params: Object.fromEntries(
                          Object.entries(ifc.ifc_params).filter(
                            ([key, value]) => value !== ""
                          )
                        ),
                      })),
                    };
                    console.log("FILTERED", filteredConfiguration);
                    handleNext(filteredConfiguration);
                  }}
                >
                  {t("next")}
                </Button>
              </Grid>
            </Tooltip>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default NetworkEth;
